import { render } from "./WalletConnect.vue?vue&type=template&id=7cd63702&scoped=true"
import script from "./WalletConnect.vue?vue&type=script&lang=js"
export * from "./WalletConnect.vue?vue&type=script&lang=js"

import "./WalletConnect.vue?vue&type=style&index=0&id=7cd63702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd63702"]])

export default __exports__